import { useEffect, useState } from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import { ArrowRight, Menu, X } from 'lucide-react'
import { cls } from '../lib/utils'

const navItems = [
  ['/', 'Home'],
  ['/about', 'About'],
  ['/product', 'Product'],
  ['/how-it-works', 'How it works'],
  ['/security', 'Security'],
  ['/integrations', 'Integrations'],
  ['/pricing', 'Pricing'],
  ['/contact', 'Contact'],
] as const

export function PublicLayout() {
  const location = useLocation()
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    setMenuOpen(false)
    window.scrollTo({ top: 0, behavior: 'auto' })
  }, [location.pathname])

  return <div className="public-site">
    <header className="public-header">
      <div className="public-header-inner">
        <Link to="/" className="public-brand" aria-label="Mail Percent home">
          <img className="mail-percent-logo" src="/images/brand/mail-percent-logo.png" alt="Mail Percent" />
          <span className="public-brand-name">Mail Percent</span>
        </Link>

        <nav className="public-nav public-nav-centered" aria-label="Primary navigation">
          {navItems.map(([path, label]) => (
            <NavLink key={path} to={path} end={path === '/'} className={({ isActive }) => cls('public-nav-link', isActive && 'active')}>
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="public-header-actions">
          <Link to="/login" className="button ghost">Sign in</Link>
          <Link to="/signup" className="button primary">Get started <ArrowRight size={15}/></Link>
        </div>

        <button className="public-menu-button" onClick={() => setMenuOpen(value => !value)} aria-label="Toggle navigation">
          {menuOpen ? <X size={21}/> : <Menu size={21}/>} 
        </button>
      </div>

      {menuOpen && <div className="public-mobile-nav">
        {navItems.map(([path, label]) => <Link key={path} to={path}>{label}</Link>)}
        <div><Link to="/login" className="button ghost">Sign in</Link><Link to="/signup" className="button primary">Get started</Link></div>
      </div>}
    </header>

    <main className="public-main"><Outlet/></main>

    <footer className="public-footer">
      <div className="public-footer-grid">
        <div className="public-footer-brand">
          <Link to="/" className="public-brand">
            <img className="mail-percent-logo" src="/images/brand/mail-percent-logo.png" alt="Mail Percent" />
            <span className="public-brand-name">Mail Percent</span>
          </Link>
          <p>Measure response timing, queue pressure, SLA Performance and team workload across the customer emails your organisation depends on.</p>
        </div>

        <div><strong>Product</strong><Link to="/product">Overview</Link><Link to="/how-it-works">How it works</Link><Link to="/integrations">Integrations</Link><Link to="/pricing">Pricing</Link></div>
        <div><strong>For teams</strong><Link to="/teams">Teams</Link><Link to="/security">Security & privacy</Link><Link to="/about">About</Link></div>
        <div><strong>Account</strong><Link to="/signup">Create account</Link><Link to="/login">Sign in</Link><Link to="/contact">Contact support</Link></div>
        <div><strong>Legal</strong><Link to="/privacy">Privacy Policy</Link><Link to="/terms">Terms of Service</Link></div>
      </div>
      <div className="public-footer-bottom"><span>© {new Date().getFullYear()} Mail Percent</span><span>Customer email operations, made visible.</span></div>
    </footer>
  </div>
}
